import React, { useEffect, useRef, useState } from 'react';
import { useSharedContext } from '../../context/SharedContext';
import { AuthenticatedUser } from '../../security/auth/AuthenticatedUser';
import { ShopifySupportApi } from '../../api/ShopifySupportApi';
import { Modal } from 'react-responsive-modal';
import { Alerter } from '../../layout/Alerter';
import "./Shopify.css";
import { MultiVendorSkuDto } from '../../api/dto/MultiVendorSkuDto';
import { MultiVendorSkuRequestDto } from '../../api/dto/MultiVendorSkuRequestDto';


export default function MultiVendorSkus() {

    const sharedContextData = useSharedContext();

    const multiVendorSkus = useRef<MultiVendorSkuDto[] | null>(null);

    const [primarySku, setPrimarySku] = useState<string>("");
    const [alternateSku1, setAlternateSku1] = useState<string>("");
    const [alternateSku2, setAlternateSku2] = useState<string>("");

    const [createNewCascade, setCreateNewCascade] = useState<boolean>(false);
    const [createOrEditCascadeOpen, setCreateOrEditCascadeOpen] = useState<boolean>(false);

    const [valueChanged, setValueChanged] = useState(0);

    const loadMultiVendorSkus = async (user: AuthenticatedUser) => {
        const lookup = await ShopifySupportApi.getMultiVendorSkus(user);
        if (lookup) {
            console.log(lookup);
            multiVendorSkus.current = lookup;
            setValueChanged(valueChanged + 1);
        } else {
            setValueChanged(valueChanged + 1);
        }
    }

    function closeCreateCascadeModal() {
        setCreateOrEditCascadeOpen(false);
    }

    function openCreateCascadeModal() {
        setPrimarySku("");
        setAlternateSku1("");
        setAlternateSku2("");
        setCreateNewCascade(true);
        setCreateOrEditCascadeOpen(true);
    }

    function openEditCascadeModal(record: MultiVendorSkuDto) {
        if (record == null) {

        }
        setPrimarySku(record.primarySku);
        setAlternateSku1(record.alternateSku1 == null ? "" : record.alternateSku1);
        setAlternateSku2(record.alternateSku2 == null ? "" : record.alternateSku2);
        setCreateNewCascade(false);

        setCreateOrEditCascadeOpen(true);
    }

    async function submitCascade(event: any) {
        event.preventDefault();

        if (primarySku == null || primarySku == '') {
            Alerter.showInfo("The Primary Sku cannot be empty - it must be a unique value", Alerter.DEFAULT_TIMEOUT);
            return;
        }

        if (alternateSku1 == null || alternateSku1 == '') {
            Alerter.showInfo("The Alternate Sku 1 cannot be empty - it must be a unique value", Alerter.DEFAULT_TIMEOUT);
            return;
        }

        const dto = new MultiVendorSkuRequestDto(primarySku, alternateSku1, alternateSku2);
        const user = sharedContextData.getAuthenticatedUser();

        if (!createNewCascade) {
            const response = await updateCascade(dto);
            if (response) {
                Alerter.showSuccess("Cascade sku was successfully updated!", Alerter.DEFAULT_TIMEOUT);
                if (user != null) {
                    await loadMultiVendorSkus(user);
                }
                closeCreateCascadeModal();
            } else {
                Alerter.showError("Saving cascade sku failed.  Try to save again.", Alerter.DEFAULT_TIMEOUT);
            }
        } else {
            const response = await saveNewCascade(dto);
            if (response) {
                Alerter.showSuccess("Saving new cascade sku was successful!", Alerter.DEFAULT_TIMEOUT);
                if (user != null) {
                    await loadMultiVendorSkus(user);
                }
                closeCreateCascadeModal();
            } else {
                Alerter.showError("Saving new cascade sku failed.  Try to save again.", Alerter.DEFAULT_TIMEOUT);
            }
        }
    }

    const saveNewCascade = async (dto: MultiVendorSkuRequestDto): Promise<boolean> => {
        const authenticatedUser = sharedContextData.getAuthenticatedUser();
        if (authenticatedUser) {
            return await ShopifySupportApi.createMultiVendorSku(dto, authenticatedUser);
        }
        console.log("Unable to find authenticated user to save new cascade sku!");
        return false;
    }

    const updateCascade = async (dto: MultiVendorSkuRequestDto): Promise<boolean> => {
        const authenticatedUser = sharedContextData.getAuthenticatedUser();
        if (authenticatedUser) {
            return await ShopifySupportApi.updateMultiVendorSku(dto, authenticatedUser);
        }
        console.log("Unable to find authenticated user to update cascade sku!");
        return false;
    }

    useEffect(() => {
        // for forcing redraw
    }, [valueChanged]);

    useEffect(() => {
        const user = sharedContextData.getAuthenticatedUser();
        console.log("User is:");
        console.log(user);
        if (user != null) {
            loadMultiVendorSkus(user)
                .catch(() => {
                        console.log("Error loading cascade multi-vendor skus")
                    })
            }
    }, []);

    return (
        <div>
            <h2><span className="ca-blue">Cascade Multi-vendor Skus</span></h2>
            {
                multiVendorSkus.current == null &&
                <div className="mmc-spinner-box spinner-border text-primary"><span className="sr-only"></span></div>
            }
            {
                multiVendorSkus.current != null &&
                <div>
                    <div className="mmc-operation-primary-button">
                        <button className="btn btn-outline-primary"
                                onClick={() => openCreateCascadeModal()}>
                            Create cascade multi-vendor Sku
                        </button>
                    </div>
                    <div className="mmc-tabular-data-container">
                        <table className="table table-striped table-hover">
                            <thead className="table-dark">
                            <tr>
                                <th>Primary Sku</th>
                                <th>Dist</th>
                                <th>Alternate Sku 1</th>
                                <th>Dist</th>
                                <th>Alternate Sku 2</th>
                                <th>Dist</th>
                                <th>Operations</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                (multiVendorSkus.current!).map(function (record) {
                                    console.log(multiVendorSkus.current);
                                    console.log(record.primarySku);
                                    return (
                                        <tr key={record.primarySku}>
                                            <td className="prevent-line-breaks">{record.primarySku}</td>
                                            <td className="prevent-line-breaks">{record.primarySkuDistributorCode}</td>
                                            <td className="prevent-line-breaks">{record.alternateSku1}</td>
                                            <td className="prevent-line-breaks">{record.alternateSku1DistributorCode}</td>
                                            <td className="prevent-line-breaks">{record.alternateSku2}</td>
                                            <td className="prevent-line-breaks">{record.alternateSku2DistributorCode}</td>
                                            <td className="prevent-line-breaks">
                                                <button className="btn btn-sm btn-outline-primary"
                                                        onClick={() => openEditCascadeModal(record)}>Edit
                                                </button>
                                                {/*<button className="btn btn-sm btn-outline-danger mmc-operation-buttons"*/}
                                                {/*        onClick={() => requestDeleteCascadeModal(sku)}>Delete*/}
                                                {/*</button>*/}
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <Modal open={createOrEditCascadeOpen}
                               onClose={closeCreateCascadeModal}
                               closeOnEsc={false}
                               closeOnOverlayClick={false}
                               showCloseIcon={false}
                               classNames={{
                                   overlay: 'customOverlay',
                                   modal: 'customEditCascadeModal',
                               }}>
                            <form onSubmit={submitCascade}>
                                <div><h2>{createNewCascade ? "Create" : "Update"} Multi-vendor Cascade Sku</h2></div>
                                <div className='row ca-form-row'>
                                    <div>
                                        <label htmlFor="primarySku" className="col-form-label">Primary Sku:</label>
                                        <input type="text" id="primarySku" className="form-control"
                                               required={true}
                                               value={primarySku}
                                               readOnly={!createNewCascade}
                                               maxLength={30}
                                               onChange={e => setPrimarySku(e.target.value)}/>
                                    </div>
                                </div>
                                <div className='row ca-form-row'>
                                    <div>
                                        <label htmlFor="alternateSku1" className="col-form-label">Alternate Sku 1:</label>
                                        <input type="text" id="alternateSku1" className="form-control"
                                               required={true}
                                               value={alternateSku1}
                                               maxLength={30}
                                               onChange={e => setAlternateSku1(e.target.value)}/>
                                    </div>
                                </div>
                                <div className='row ca-form-row'>
                                    <div>
                                        <label htmlFor="alternateSku2" className="col-form-label">Alternate Sku 2:</label>
                                        <input type="text" id="alternateSku2" className="form-control"
                                               required={false}
                                               value={alternateSku2}
                                               maxLength={30}
                                               onChange={e => setAlternateSku2(e.target.value)}/>
                                    </div>
                                </div>

                                <div className="row mmc-form-button-row">
                                    <div className='modal-navigation-row justify-content-end'>
                                        <button className="btn btn-outline-primary" type="submit">Save changes</button>
                                        &nbsp;
                                        <button className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={closeCreateCascadeModal}>Cancel
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Modal>
                    </div>

                    {/*<div>*/}
                    {/*    <Modal open={deleteSkuOpen}*/}
                    {/*           onClose={closeDeleteSkuModal}*/}
                    {/*           closeOnEsc={false}*/}
                    {/*           closeOnOverlayClick={false}*/}
                    {/*           showCloseIcon={false}*/}
                    {/*           classNames={{*/}
                    {/*               overlay: 'customOverlay',*/}
                    {/*               modal: 'deleteCustomSkuModal',*/}
                    {/*           }}>*/}
                    {/*        <form onSubmit={submitDeleteSku}>*/}
                    {/*            <div><h2>{`Delete Sku for ${selectedDistributor.current!.name}`}</h2></div>*/}
                    {/*            <div className='mmc-label-header'>*/}
                    {/*                <div className="mmc-label">MMC Sku:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.sku}</div>*/}
                    {/*            </div>*/}
                    {/*            <div className='mmc-label-row'>*/}
                    {/*                <div className="mmc-label">Distributor Sku:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.distributorSku}</div>*/}
                    {/*            </div>*/}
                    {/*            <div className='mmc-label-row'>*/}
                    {/*                <div className="mmc-label">Brand:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.brand}</div>*/}
                    {/*                <div className="mmc-label">Style Code:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.styleCode}</div>*/}
                    {/*            </div>*/}
                    {/*            <div className='mmc-label-row'>*/}
                    {/*                <div className="mmc-label">Part Id:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.partId}</div>*/}
                    {/*                <div className="mmc-label">Color:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.color}</div>*/}
                    {/*            </div>*/}
                    {/*            <div className='mmc-label-row'>*/}
                    {/*                <div className="mmc-label">Color Code:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.colorCode}</div>*/}
                    {/*                <div className="mmc-label">Size Code:</div>*/}
                    {/*                <div className="mmc-value">{selectedSku?.sizeCode}</div>*/}
                    {/*            </div>*/}

                    {/*            <div className="row mmc-form-button-row">*/}
                    {/*                <div className='modal-navigation-row justify-content-end'>*/}
                    {/*                    <button className="btn btn-outline-danger" type="submit">Yes, Delete This!*/}
                    {/*                    </button>*/}
                    {/*                    &nbsp;*/}
                    {/*                    <button className="btn btn-outline-secondary"*/}
                    {/*                            type="button"*/}
                    {/*                            onClick={closeDeleteSkuModal}>Cancel*/}
                    {/*                    </button>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </form>*/}
                    {/*    </Modal>*/}
                    {/*</div>*/}

                </div>
            }
        </div>
    )
        ;
}
